import React from "react";
import { GraduationCap } from "lucide-react";
import TalentDirectory from "./TalentDirectory";

function Faculties() {
    return (
        <TalentDirectory
            title="Hire Faculties"
            subtitle="Experienced teaching faculty for colleges and institutes."
            matchTypes={["faculty", "faculties", "professor", "lecturer"]}
            icon={GraduationCap}
        />
    );
}

export default Faculties;
